export const knowledgeBasePath = () => "/knowledge-bases";
export const knowledgeBaseEditPath = (base) => `/knowledge-bases/${base.id}`;
export const knowledgeBaseNewPath = () => "/knowledge-bases/new";
